<template>
  <div>
    <header class="reHeader">
      <p class="regHeader">
        <span class="imgDiv" v-on:click="backHistory">
          <!--<img src="@/assets/img/back.png" alt="">-->
          <van-icon size="22px" name="arrow-left" />
        </span>
        <span>找回密码</span></p>
    </header>

    <form style="margin-top: 90px">
      <input type="number" class="mobile" v-model="form.userCode" placeholder="请输入手机号码">
      <p class="mobile-err err"></p>
      <div class="regcode divflex">
        <input type="number" class="codetxt" v-model="form.phoneCode" placeholder="请输入验证码">
        <input type="button" class="regcodebtn" v-on:click='onLogin':disabled="phoneBool"  v-model="countDown" value="获取验证码">
      </div>
      <p class="code-err err"></p>
      <input type="password" class="password" v-model="form.passWord1" placeholder="请输入密码">
      <p class="password-err err"></p>
      <input type="password" class="passwordagain" v-model="form.passWord2" placeholder="请再次输入密码">
      <p class="passwordagain-err err"></p>

      <input type="button" value="找回密码" @click="register()" class="endButton">
    </form>
    <!-- 协议弹框 -->

  </div>
</template>

<script>
  export default {
    name: 'message',
    data () {
      return {
        form:{
          userCode:'',//手机号
          password:'',
          phoneCode:'',//手机验证码
          phone:'',
          passWord1:'',
          passWord2:'',
        },
        showRadio:false,
        countDown:'获取验证码',
        num:60,//验证码倒计时
        bool:false,//验证码不可点
        phoneBool:false,
        code:"a",//接受手机验证码
        userId:'',
        passWord:"",
        password1:'',
        radio:"1"
      }
    },
    methods:{
      radioClick(){
        this.showRadio=!this.showRadio
      },
      close(){
        this.bool=false
      },
      backHistory(){
        this.$router.go(-1)
      },
      onLogin(){//发送验证码
        if(this.form.userCode=='') return this.$toast("请输入手机号")
        this.$api.login({mobile:this.form.userCode}).then(res => {
          this.userid=localStorage.getItem("userid")
          var _this=this
          if(res.status==200){
            this.countDown=this.num+"秒后重发"
            var time=setInterval(function () {
              _this.num--
              if(_this.num==0){
                _this.countDown='获取验证码'
                _this.phoneBool=false
                clearInterval(time)
                _this.num=60
              }else {
                _this.countDown=_this.num+"秒后重发"
                _this.phoneBool=true
              }
            },1000)
            this.code=res.code
          }
        })
          .catch(err => {
//            reject(err.data)
          })
      },
      register(){//发送验证码
        if(this.form.userCode=='') return this.$toast("请输入手机号")
        if(this.form.phoneCode=='') return this.$toast("请输入验证码")
        if(this.form.passWord1=='') return this.$toast("请输入密码")
        if(this.form.passWord1===this.form.passWord2){
          if(this.code!=this.form.phoneCode)return this.$toast("验证码错误")
          this.$api.retrievePwd(
            {
              "mobile":this.form.userCode,
              "password":this.form.passWord1
            }).then(res => {
            if(res.status==300){
              this.$toast(res.msg)
            }else if(res.status==200){
              this.$toast("成功")
              this.$router.push("/log")
            }
          })
            .catch(err => {
//            reject(err.data)
            })
        }else {
          this.$toast("俩次输入的密码不一致，请重新输入")
        }

      },
    }


  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped="">
  @import '../assets/css/common.css';
  /*@import '../assets/css/header.css';*/
  /*@import '../assets/css/footer.css';*/
  @import '../assets/css/register.css';
  .imgDiv{
    /*background: #6e9bcf*/
  }
  .end{
    display: flex;
    align-items: center;
  }
  .imgDiv img{
    width: 20px;
    display: flex;
    align-items: center;
  }
  .regHeader{
    display: flex;
    padding-left: 15px;

  }
  .reHeader{
    width: 100%;
    height: 65px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    /*justify-content: space-between;*/
    align-items: center;
    color: #FFFFFF;
  }
  /deep/.van-icon{
    top:2px
  }
  .endButton{
    display: block;
    width: 100%;
    /* margin: 0 auto; */
    height: 50px;
    background-color: #6e9bcf;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/findWord.vue